import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "65",
  height: "66",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F5F5F5",
      d: "M0 10.898c0-5.522 4.477-10 10-10h45c5.523 0 10 4.478 10 10v44.794c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-opacity": ".3",
      d: "M23.887 14.854h-8.725c-.939 0-1.489 1.054-.95 1.82l9.452 13.361a12.73 12.73 0 0 1 7.943-3.564l-6.792-11.055c-.145-.349-.522-.562-.928-.562m26.026 0h-8.66c-.409 0-.786.213-.996.562l-6.73 11.056a12.73 12.73 0 0 1 7.943 3.565l9.451-13.361c.544-.768-.007-1.822-1.008-1.822"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "M32.571 26.423c-7.054 0-12.766 5.693-12.766 12.724S25.52 51.872 32.57 51.872c7.051 0 12.767-5.694 12.767-12.725s-5.709-12.724-12.767-12.724m6.71 11.372-2.748 2.675.644 3.778c.118.669-.598 1.193-1.206.867l-3.4-1.78-3.402 1.777c-.607.325-1.323-.199-1.206-.868l.644-3.777-2.748-2.675c-.498-.481-.215-1.32.467-1.421l3.8-.551 1.698-3.433a.81.81 0 0 1 .744-.46c.299 0 .598.157.743.46l1.705 3.434 3.8.552c.69.1.966.938.465 1.422"
    }, null, -1)
  ])))
}
export default { render: render }